import { refreshSession } from './api';
import { setToken, setUser, getUser, getToken } from './auth';

// Silent, throttled JWT refresh — keeps native app users "always logged in"
// by sliding the token window forward whenever the app is opened/focused.
let lastRefresh = 0;
let inFlight = null;

export const silentRefresh = async () => {
  if (!getToken()) return;
  if (Date.now() - lastRefresh < 60000) return; // throttle to once/min
  if (inFlight) return inFlight;
  inFlight = refreshSession()
    .then((res) => {
      if (res.data?.token) {
        setToken(res.data.token);
        if (res.data.user) setUser({ ...getUser(), ...res.data.user });
        lastRefresh = Date.now();
      }
    })
    .catch(() => {})
    .finally(() => { inFlight = null; });
  return inFlight;
};
